/* eslint-disable max-len */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useEffect, useRef, useState } from 'react'
import Button from '../../../components/Button'
import ErrorMessage from '../../../components/ErrorMessage';
import FloatingInput from '../../../components/FloatinInput/FloatingInput';
const EmailModal = ({ handleSubmit, loading, handleClose, bodyFocus
    , setBodyFocus
    , subjectFocus
    , setSubjectFocus
    , bodyContent
    , subject
    , setSubject
    , subjectError
    , setSubjectError
    , setBody
    , bodyError
    , setBodyError }) => {
    // const [status, setStatus] = useState('');
    return (
        <div className=" w-[352px] bg-white">
            <div className="flex pb-4 justify-between">
                <h1 className="text-lg font-normal text-[#1f1f1f]">
                    Send Email
                </h1>
                <img src="/assets/images/close-24px.svg" data-testid="close-button" onClick={handleClose} className=' mr-[-4px]' alt="" />
            </div>
            <div className='flex flex-col'>
                <div className={`relative pl-[16px] py-[16px] mt-4 w-[352px] border 
                     ${subjectError ? 'border-[#FC4523] mb-[24px]' : 'border-[#DDD] mb-[24px]'}`}>
                    <input
                        id="subject"
                        data-testid="subject"
                        onFocusCapture={() => setSubjectFocus(true)}
                        onBlurCapture={() => setSubjectFocus(false)}
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        onFocus={() => {
                            setSubjectError('')
                            setBodyError('')
                        }}
                        className={` caret-[#9e2063ab] text-justify mt-1 w-[278px] resize-none 
                            focus:outline-none focus:border-0 text-[14px] font-semibold leading-[22px] overflow-y-auto sidebar
                            ${subjectError ? 'text-[#FC4523]' : 'text-[#1F1F1F]'}`}
                    />
                    <label htmlFor="subject"
                        className={`absolute mt-1 left-4 transition-all duration-300 
                            ${subjectError ? 'text-[#FC4523]' : 'text-[#1F1F1F]'}  
                            ${subject?.length > 0 || subjectFocus ? '-translate-y-3.5 font-normal text-[12px] leading-[16px]'
            : 'top-4 text-[14px] font-semibold leading-[22px]'} `}>
                        Subject
                    </label>
                    <p className={`absolute bottom-0 right-0 p-2 font-semibold text-[14px] leading-[22px] 
                        ${subjectError ? 'text-[#FC4523]' : 'text-[#8E8E8E]'}`}>{subject?.length || 0}/200</p>
                    {subjectError &&
                        <ErrorMessage classKey='font-normal text-[12px] leading-[18px] mt-5 text-[#FC4523] absolute'
                            error={subjectError} message={subjectError} />}
                </div>
                <div className={`relative pl-[16px] py-[16px] mt-4 h-[120px] w-[352px] border 
                     ${bodyError ? 'border-[#FC4523] mb-[24px]' : 'border-[#DDD] mb-[24px]'}`}>
                    <textarea
                        id="body-content"
                        data-testid="body-content"
                        onFocusCapture={() => setBodyFocus(true)}
                        onBlurCapture={() => setBodyFocus(false)}
                        value={bodyContent}
                        onChange={(e) => setBody(e.target.value)}
                        onFocus={() => {
                            setSubjectError('')
                            setBodyError('')
                        }}
                        className={`h-[90px] caret-[#9e2063ab] text-justify mt-1 w-[264px] resize-none 
                            focus:outline-none focus:border-0 text-[14px] font-semibold leading-[22px] overflow-y-auto sidebar
                            ${bodyError ? 'text-[#FC4523]' : 'text-[#1F1F1F]'}`}
                    />
                    <label htmlFor="body"
                        className={`absolute mt-1 left-4 transition-all duration-300 
                            ${bodyError ? 'text-[#FC4523]' : 'text-[#1F1F1F]'}  
                            ${bodyContent?.length > 0 || bodyFocus ? '-translate-y-3.5 font-normal text-[12px] leading-[16px]'
            : 'top-4 text-[14px] font-semibold leading-[22px]'} `}>
                        Email content
                    </label>
                    <p className={`absolute bottom-0 right-0 p-2 font-semibold text-[14px] leading-[22px] 
                        ${bodyError ? 'text-[#FC4523]' : 'text-[#8E8E8E]'}`}>{bodyContent?.length || 0}/2000</p>
                    {bodyError &&
                        <ErrorMessage classKey='font-normal text-[12px] leading-[18px] mt-1 text-[#FC4523] absolute'
                            error={bodyError} message={bodyError} />}
                </div>
            </div>

            <div className="flex justify-end space-x-2 mt-6 items-center">
                <button className="px-4 rounded-[12px] text-primary items-center" onClick={() => handleClose()} data-testid="cancel-btn">Cancel</button>
                <>
                    <Button
                        handleClick={handleSubmit}
                        loading={loading}
                        disabled={loading}
                        text="Send"
                        classKey="px-4 py-[10px] bg-primary text-white rounded-[12px]"
                        type="submit"
                        testId="confirm-btn"
                        smallLoader
                    /></>
            </div>
        </div>
    )
}
export default EmailModal